module.exports = __webpack_public_path__ + "img/puptitle8.eb65f788.png";